import { render, staticRenderFns } from "./ImageComments.vue?vue&type=template&id=3c32c15f&scoped=true"
import script from "./ImageComments.vue?vue&type=script&lang=ts"
export * from "./ImageComments.vue?vue&type=script&lang=ts"
import style0 from "./ImageComments.vue?vue&type=style&index=0&id=3c32c15f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c32c15f",
  null
  
)

export default component.exports